"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var os_1 = require("os");
var common_1 = require("./common");
exports.networkIds = function (original) {
    if (original === void 0) { original = true; }
    var networkIntfs = os_1.networkInterfaces() || {};
    var netIds = [];
    Object.keys(networkIntfs).forEach(function (intfsProp) {
        Object.keys(networkIntfs[intfsProp]).forEach(function (adapterProp) {
            var iNet = networkIntfs[intfsProp][adapterProp];
            if (iNet && iNet.address.length && !iNet.internal && iNet.mac !== '00:00:00:00:00:00') {
                if (netIds.indexOf(iNet.mac) === -1) {
                    netIds.push(iNet.mac);
                }
            }
        });
    });
    if (netIds.length === 0) {
        netIds.push(os_1.hostname());
    }
    return original ? netIds : netIds.map(function (netId) { return common_1.hash(netId); });
};
exports.networkId = function (original) {
    if (original === void 0) { original = true; }
    var netId = exports.networkIds(original)[0];
    return original ? netId : common_1.hash(netId);
};
//# sourceMappingURL=networkId.js.map